import * as React from 'react';

export function formatDocumentTitle(
  pageTitle: string,
  appName = 'Open Dataroom'
): string {
  return `${pageTitle} — ${appName}`;
}

export function useDocumentTitle(title: string) {
  React.useEffect(() => {
    document.title = title;
  }, [title]);
}
